import { Component, inject, OnInit, signal } from '@angular/core';
import { BreadCrumbsComponent } from '../../core/components/ui/bread-crumbs/bread-crumbs.component';
import { BreadCrumbService } from '../../core/services/bread-crumb.service';
import { IBreadCrumb } from '../../core/interface/bread-crumb';
import { ContainerComponent } from '../../core/components/block/container/container.component';
import { DecimalPipe, NgClass, NgStyle } from '@angular/common';
import { DashboardChart } from '../../core/components/block/dashboard-chart/dashboard-chart';
import { StatsDashboardComponent } from '../../core/components/block/stats-dashboard/stats-dashboard.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PaginatorComponent } from '../../core/components/ui/paginator/paginator.component';
import { DashboardService } from '../../core/services/dashboard.service';
import { Dashboard } from '../../core/models/dashboard.models';
import { DashboardPraModels } from '../../core/models/dashboard-pra.models';
import { PageModel } from '../../core/models/page.models';
import { RegionAssessmentComponent } from './region-assessment/region-assessment.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    BreadCrumbsComponent,
    ContainerComponent,
    NgClass,
    NgStyle,
    DecimalPipe,
    DashboardChart,
    StatsDashboardComponent,
    RouterLink,
    PaginatorComponent,
    RegionAssessmentComponent,
  ],
  templateUrl: './dashboard.component.html',
  standalone: true,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  private dashboardService = inject(DashboardService);
  private route = inject(ActivatedRoute);
  private breadCrumbService = inject(BreadCrumbService);
  dashboard = signal<Dashboard | null>(null);
  validityProjects = signal<DashboardPraModels[]>([]);
  page: PageModel | null = null;

  breadCrumbs: IBreadCrumb[] = [
    { labels: ['Головна'], to: '/' },
    { labels: ['Регуляторний дашборд'], to: '/dashboard' },
  ];

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.dashboard.set(data['dashboard']);
      this.page = data['page'];
    });
    this.breadCrumbService.breadCrumbs.set(this.breadCrumbs);

    this.indicators().forEach((item) => {
      this.selectedPeriods[item.id] = '1';
    });

    this.updatePaginatedList();
    this.getHistoryPra();
  }

  getHistoryPra() {
    this.dashboardService
      .getValidityProject({
        take: this.itemsPerPage,
        skip: (this.currentPage - 1) * this.itemsPerPage,
      })
      .subscribe((res) => {
        this.validityProjects.set(res.data);
        this.totalItems = res.count;
        this.updatePaginatedList();
      });
  }

  hovered: string | null = null;

  total(): number {
    const dash = this.dashboard();
    if (!dash) return 0;
    return (
      (dash.large || 0) +
      (dash.medium || 0) +
      (dash.small || 0) +
      (dash.micro || 0)
    );
  }

  getPercentage(value: number): string {
    return (value / this.total()) * 100 + '%';
  }

  hover(type: string | null) {
    this.hovered = type;
  }

  getColor(type: string): string {
    const colors: Record<string, string> = {
      large: 'green',
      medium: 'purple',
      small: 'blue',
      micro: 'yellow',
    };
    return colors[type] || 'gray';
  }

  selectedPeriods: { [id: number]: '1' | '5' } = {};

  switchPeriod(id: number, period: '1' | '5') {
    this.selectedPeriods[id] = period;
  }

  indicators(): {
    id: number;
    title: string;
    values: { [key: string]: number };
  }[] {
    const dash = this.dashboard();
    if (!dash) return [];
    const result = [];
    if (dash.smallBusinessCosts) {
      result.push({
        id: 1,
        title: 'Сумарні витрати суб’єктів малого підприємництва',
        values: {
          '1': dash.smallBusinessCosts.firstYear || 0,
          '5': dash.smallBusinessCosts.fiveYears || 0,
        },
      });
    }
    if (dash.budgetCosts) {
      result.push({
        id: 2,
        title: 'Бюджетні витрати',
        values: {
          '1': dash.budgetCosts.firstYear || 0,
          '5': dash.budgetCosts.fiveYears || 0,
        },
      });
    }
    if (dash.bizCostsLargeMedium) {
      result.push({
        id: 3,
        title: 'Сумарні витрати великих та середніх',
        values: {
          '1': dash.bizCostsLargeMedium.firstYear || 0,
          '5': dash.bizCostsLargeMedium.fiveYears || 0,
        },
      });
    }
    return result;
  }

  totalItems = 0;
  currentPage: number = 1;
  itemsPerPage: number = 4;

  onPageChange(page: number) {
    this.currentPage = page;
    this.getHistoryPra();
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.validityProjects().slice(start, end);
  }
}
